export default __webpack_public_path__ + "static/media/new_white_download_icon.4e35d064.svg";